export const version = "1.7.21-daily-20261022-0";
export const channel = "daily";
export const gitcommit = "78dd002d3";
